import React, { useEffect, useRef } from "react";
import { useSquarespaceContent } from "../hooks/useSquarespaceContent";

const AboutSection = () => {
  const { content, loading, error } = useSquarespaceContent();
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  // Debug logging
  console.log('AboutSection render - content:', content);
  console.log('AboutSection render - loading:', loading);
  console.log('AboutSection render - error:', error);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          } else {
            entry.target.classList.remove("animate-in");
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Show loading state or return null if content is not loaded
  if (loading) {
    return (
      <section id="about" className="about-section section" ref={sectionRef}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About</h2>
            <hr className="section-divider" />
          </div>
          <div className="section-grid">
            <div className="section-content">
              <p>Loading content...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Show error state if there's an error
  if (error) {
    return (
      <section id="about" className="about-section section" ref={sectionRef}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About</h2>
            <hr className="section-divider" />
          </div>
          <div className="section-grid">
            <div className="section-content">
              <p>Error loading content: {error}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Show fallback if content is null or missing about section
  if (!content || !content.about) {
    return (
      <section id="about" className="about-section section" ref={sectionRef}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About</h2>
            <hr className="section-divider" />
          </div>
          <div className="section-grid">
            <div className="section-content">
              <p>Content not available</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="about" className="about-section section" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{content.about.title}</h2>
          <hr className="section-divider" />
        </div>
        
        <div className="section-grid">
          <div className="section-image">
            <img
              src={content.about.image}
              alt={content.about.imageAlt}
              className="animate-element"
            />
          </div>
          <div className="section-content" ref={contentRef}>
            <div className="animate-element">
              <h3 className="section-heading">{content.about.heading}</h3>
              <div className="section-text">
                <p className="section-description">{content.about.description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;